import React from 'react';
import { Workflow, Users, Building2, Plug } from 'lucide-react';
import { IconAdjustmentsAlt, IconPointerCollaboration2 } from '@tabler/icons-react';
import CustomersAffiliateIcon from '../../components/icons/IconAffiliate';
import { hasGoAppLicense } from '../../utils/userFinanceiroAccess';
import ConfigHubSearch from './ConfigHubSearch';
import {
  CONFIG_ROUTE_PROCESSOS,
  CONFIG_ROUTE_GO,
  CONFIG_ROUTE_USUARIOS,
  CONFIG_ROUTE_CUSTOMERS,
  CONFIG_ROUTE_EMPRESA,
  CONFIG_ROUTE_PAINEL_CONTROLE,
  INTEGRACOES_ROUTE_BASE,
} from './configHubCatalog';
import { navigateConfig } from './configNavMotion';
import './ConfigHubView.css';

/**
 * Hub de entrada de Configurações — cards por assunto, sem barra de abas.
 */
export default function ConfigHubView({ currentUser, onNavigate }) {
  const hasCustomers = Number(currentUser?.verve_customers_module) === 1;
  const hasGo = hasGoAppLicense(currentUser);

  const sections = [
    {
      id: 'operacao',
      title: 'Operação',
      items: [
        {
          id: 'process',
          title: 'Processos',
          description: 'Fluxos de abertura, status, SLA e regras do atendimento.',
          path: CONFIG_ROUTE_PROCESSOS,
          Icon: Workflow,
          iconKind: 'lucide',
        },
      ],
    },
    {
      id: 'ecosistema',
      title: 'Ecosistema Vervify',
      items: [
        hasGo
          ? {
              id: 'go',
              title: 'Go',
              description: 'App móvel: dispositivos, usuários e permissões de campo.',
              path: CONFIG_ROUTE_GO,
              Icon: IconPointerCollaboration2,
              iconKind: 'tabler',
            }
          : null,
        hasCustomers
          ? {
              id: 'usersCustomers',
              title: 'Customers',
              description: 'Acesso e processos do portal do cliente.',
              path: CONFIG_ROUTE_CUSTOMERS,
              Icon: CustomersAffiliateIcon,
              iconKind: 'affiliate',
            }
          : null,
        hasCustomers
          ? {
              id: 'integrations',
              title: 'Integrações',
              description: 'Conexões com logística, área técnica e sistemas externos.',
              path: INTEGRACOES_ROUTE_BASE,
              Icon: Plug,
              iconKind: 'lucide',
            }
          : null,
      ].filter(Boolean),
    },
    {
      id: 'sua-empresa',
      title: 'Sua empresa',
      items: [
        {
          id: 'users',
          title: 'Usuários',
          description: 'Contas, papéis, permissões e vínculo com sugestões.',
          path: CONFIG_ROUTE_USUARIOS,
          Icon: Users,
          iconKind: 'lucide',
        },
        {
          id: 'company',
          title: 'Empresa',
          description: 'Dados da empresa, marca e parâmetros institucionais.',
          path: CONFIG_ROUTE_EMPRESA,
          Icon: Building2,
          iconKind: 'lucide',
        },
        {
          id: 'painelControle',
          title: 'Painel de controle',
          description: 'Preferências gerais do sistema e opções avançadas.',
          path: CONFIG_ROUTE_PAINEL_CONTROLE,
          Icon: IconAdjustmentsAlt,
          iconKind: 'tabler',
        },
      ],
    },
  ].filter((s) => s.items.length > 0);

  return (
    <div className="config-hub">
      <header className="config-hub-header">
        <div className="config-hub-header-main">
          <h1 className="config-hub-title">Configurações</h1>
          <p className="config-hub-subtitle">
            Operação, ecossistema Vervify e dados da sua empresa — escolha por onde começar.
          </p>
        </div>
        <div className="config-hub-header-search">
          <ConfigHubSearch
            currentUser={currentUser}
            onNavigate={(path) => navigateConfig(onNavigate, path, 'forward')}
            showStorage
            configSection="hub"
          />
        </div>
      </header>

      <div className="config-hub-body">
        {sections.map((section) => (
          <section key={section.id} className="config-hub-section" aria-labelledby={`config-hub-${section.id}`}>
            <h2 id={`config-hub-${section.id}`} className="config-hub-section-title">
              {section.title}
            </h2>
            <div className="config-hub-grid">
              {section.items.map((item) => {
                const Icon = item.Icon;
                return (
                  <button
                    key={item.id}
                    type="button"
                    className="config-hub-card"
                    onClick={() => navigateConfig(onNavigate, item.path, 'forward')}
                  >
                    <span className="config-hub-card-icon" aria-hidden>
                      {item.iconKind === 'tabler' || item.iconKind === 'affiliate' ? (
                        <Icon size={18} stroke={1.75} />
                      ) : (
                        <Icon size={18} strokeWidth={1.75} />
                      )}
                    </span>
                    <span className="config-hub-card-text">
                      <span className="config-hub-card-title">{item.title}</span>
                      <span className="config-hub-card-desc">{item.description}</span>
                    </span>
                  </button>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
